import './style.scss';
import { useInitPage } from 'hooks/useInitPage';
import FullscreenPopup from 'components/PanoPopup/FullscreenPopup';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TienIchPage = (props) => {
  const { sceneId } = useInitPage(props.location.pathname);
  const history = useHistory();
  return (
    <FullscreenPopup
      isOpen={true}
      onClose={() => history.push('/')}
      sceneId={sceneId}
      isPage
    />
  );
};

export default TienIchPage;
